import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BudgetPreviewComponent } from './budget-preview/budget-preview.component';
import { HomeComponent } from './home/home.component';
import { SpecificationsComponent } from './specifications/specifications.component';
import { CupraCareFormComponent } from './cupra-care-form/cupra-care-form.component';
import { CupraDateFormComponent  } from './cupra-date-form/cupra-date-form.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';



const routes: Routes = [
  { path: 'home', component: HomeComponent, data: { title: 'Inicio', animation: 'home' } },
  { path: 'specifications/:id', component: SpecificationsComponent, data: { title: 'Datos del vehículo', animation: 'specs' } },
  { path: 'budget-preview/:id', component: BudgetPreviewComponent, data: { title: 'Presupuesto', animation: 'budget' } },
  { path: 'cupra-care/:id', component: CupraCareFormComponent, data: { title: 'CUPRA CARE', animation: 'budget' } },
  { path: 'cupra-date/:id', component: CupraDateFormComponent, data: { title: 'Solicitud de cita', animation: 'budget' } },
  { path: 'politica-cookies', component: PoliticaCookiesComponent, data: { title: 'Política de cookies', animation: 'public' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
